import { Rating, styled } from '@mui/material';

export const HBRatingRootStyle = styled(Rating)(({ theme }) => ({}));
